// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Panel":"bcq_a bhj_cw bhj_jx bhj_jo bhj_rh bhj_vf"};